import React from "react";
import AlertDetailsComponent from "./AlertDetailsComponent";
import { graphColor } from "../Breaches/BreachConstants";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';

interface IProps {
    alertInfo: any;
    isTUAlert?: boolean;
    isBreachDetail?: boolean;
}

const NameAddress = ({ alertInfo, isTUAlert, isBreachDetail }: IProps) => {
    const history = useHistory();
    const iframeHeight = isTUAlert ? "140px" : "300px";
    const { t: tLang } = useTranslation();

    const renderIframe = () => {
        return (
            <div role="row" className="data-row row">
                {Boolean(alertInfo[0].alertDetails.rawContentUrl) ? (
                    <iframe
                        style={{ height: iframeHeight }}
                        src={alertInfo[0].alertDetails.rawContentUrl}
                        title="description"
                        className="col-xs-12 col-sm-12 col-no-gutter"
                    ></iframe>
                ) : (
                    <iframe
                        style={{ height: "300px" }}
                        src={alertInfo[0].alertDetails.alertItemDetails["Alert Url"]}
                        title="description"
                        className="col-xs-12 col-sm-12 col-no-gutter"
                    ></iframe>
                )}
            </div>
        );
    };

    const renderBreachDetail = (breachDetail: any) => {
        return breachDetail && breachDetail["status"] === "COMPLETED" ? (
            <>
                <div role="row" className="data-row row">
                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                        <div className="data-label" id="alert1-address1">
                            Breached Organization
                        </div>
                    </div>
                    <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                        <div className="data-value" aria-labelledby="alert1-address1">
                            {breachDetail["organizationName"]}
                        </div>
                    </div>
                </div>
                <div role="row" className="data-row row">
                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                        <div className="data-label" id="alert1-address2">
                            Breach Risk Rating
                        </div>
                    </div>
                    <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                        <div className="data-value" aria-labelledby="alert1-address2">
                            <div style={{ display: "flex" }}>
                                <div className={`alert-breach-score ${graphColor[breachDetail["score"]]["textColor"]}`}>{breachDetail["score"]}</div>
                                <div className={`alert-breach-score-text ${graphColor[breachDetail["score"]]["cardBg"]}`}>
                                    <span className={`score-text ${graphColor[breachDetail["score"]]["textColor"]}`}>
                                        {graphColor[breachDetail["score"]]["text"]}
                                    </span>
                                    <span className={`score-out-of ${graphColor[breachDetail["score"]]["textColor"]}`}>({breachDetail["score"]} of 10)</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {breachDetail && breachDetail["actionList"] && breachDetail["actionList"]["actionList"].length ? (
                    <div role="row" className="data-row row">
                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                            <div className="data-label" id="alert1-address3">
                                How Do I Protect MySelf?
                            </div>
                        </div>
                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                            <div className="data-value" aria-labelledby="alert1-address3">
                                <ul className="breach-alert-list">
                                    {breachDetail["actionList"]["actionList"].map((action: any) => (
                                        <li key={action.id} className="list-style-disc">
                                            {action.name}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                ) : (
                    <></>
                )}
            </>
        ) : (
            <></>
        );
    };

    const redirectBreachDetail = (breachDetail: any) => {
        if (breachDetail) {
            history.push({
                pathname: `/breaches/breach-details`,
                state: {
                    id: breachDetail["breachId"],
                    backPage: "breach_alert",
                    orgName: breachDetail["organizationName"],
                    breachDate: breachDetail["breachDate"],
                },
            });
        }
    };

    const alertDetailsLabels: Record<string, string> = {
        "Source Category": tLang("alerts.alerts.activeAlertPopup.alertDetailsLabels.sourceCategory"),
        "Credit Card Number": tLang("alerts.alerts.activeAlertPopup.alertDetailsLabels.creditCardNumber"),
        "Passport Number": tLang("alerts.alerts.activeAlertPopup.alertDetailsLabels.passportNumber"),
        "Account Takeover Risk": tLang("alerts.alerts.activeAlertPopup.alertDetailsLabels.accountTakeoverRisk"),
        "Recommendations": tLang("alerts.alerts.activeAlertPopup.alertDetailsLabels.recommendations"),
        "Type": tLang("alerts.alerts.activeAlertPopup.alertDetailsLabels.type"),
        "Description": tLang("alerts.alerts.activeAlertPopup.alertDetailsLabels.description"),
        "Name": tLang("alerts.alerts.activeAlertPopup.alertDetailsLabels.name"),
        "Date": tLang("alerts.alerts.activeAlertPopup.alertDetailsLabels.date"),
        "User Name": tLang("alerts.alerts.activeAlertPopup.alertDetailsLabels.userName"),
        "Drivers License Number": tLang("alerts.alerts.activeAlertPopup.alertDetailsLabels.driversLicenseNumber"),
        "Bank Account": tLang("alerts.alerts.activeAlertPopup.alertDetailsLabels.bankAccount"),
        "Mothers Maiden Name": tLang("alerts.alerts.activeAlertPopup.alertDetailsLabels.mothersMaidenName"),
        "Social Insurance Number": tLang("alerts.alerts.activeAlertPopup.alertDetailsLabels.sin"),
        "International Bank Account Number": tLang("alerts.alerts.activeAlertPopup.alertDetailsLabels.internationalBankAccountNo")
    };

    const getAlertDetailsLabel = (alertKey: string): string => {
        return alertDetailsLabels[alertKey] || alertKey;
    };

    const renderAlertDetails = () => {
        return (
            <div role="row">
                {alertInfo.map((alertDetails: any, index: number) => {
                    if (!!alertDetails && !!alertDetails.alertDetails) {
                        let breachDetail = alertDetails?.alertBreachDetails;
                        let details = alertDetails.alertDetails?.alertItemDetails;
                        let keys = Object.keys(details);

                        return (
                            <div role="gridcell" className="data-grid has-lines" style={{ borderBottom: alertInfo.length > 1 ? "1px solid" : "none" }} key={index}>
                                {index !== 0 && isBreachDetail ? (
                                    <div className="data-row row breach-alert-title-main" style={{ marginTop: "0.5rem" }}>
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <h5 className="breach-alert-text">Details Summary</h5>
                                        </div>
                                        {breachDetail && breachDetail["status"] === "COMPLETED" ? (
                                            <div className="col-xs-12 col-sm-8 col-no-gutter text-align-sm-end text-align-right">
                                                <button
                                                    className="btn-default btn-breach-primary breach-alert-btn-width btn-search-bg-color"
                                                    onClick={() => redirectBreachDetail(breachDetail)}
                                                >
                                                    View Full Breach Alert
                                                </button>
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                ) : (
                                          <></>
                                )}

                                {keys.map((key: any, index: any) => (
                                    <div className="data-row row" key={key}>
                                        <div className="col-xs-12 col-sm-4 col-no-gutter padding-right-xs">
                                            <div className="data-label" id={`alert-address${index}`}>
                                                {getAlertDetailsLabel(key)}
                                            </div>
                                        </div>
                                        {key === "Address" ? (
                                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div
                                                    className="data-value"
                                                    dangerouslySetInnerHTML={{ __html: alertDetails.alertDetails.alertItemDetails[key] }}
                                                ></div>
                                            </div>
                                        ) : (
                                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div className={`data-value ${key === "Password" ? "" : "text-capitalize"}`}>
                                                    {alertDetails.alertDetails.alertItemDetails[key]}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                                {(alertInfo[0].serviceType === "CreditActivityAlert" || alertInfo[0].serviceType === "ChildCreditActivityMonitoring") && (
                                    <p
                                        style={{
                                            borderTop: "1px solid rgba(200,201,199,.5)",
                                            paddingTop: "15px",
                                        }}
                                    >
                                        Credit activity includes any credit information complied by TransUnion typically for the purpose of inclusion in a consumer
                                        credit report. Categories include personal information, account summary, inquiries, revolving & installment accounts and
                                        public records.
                                    </p>
                                )}
                                {renderBreachDetail(breachDetail)}
                            </div>
                        );
                    }
                })}
            </div>
        );
    };

    const renderTUAlerts = () => {
        return <AlertDetailsComponent alertDetails={alertInfo[0]?.alertDetails} />;
    };

    const renderAlerts = () => {
        if (
            (alertInfo[0].serviceType === "CRDALRT" && alertInfo[0].alertDetails.rawContentUrl && alertInfo[0].alertDetails.rawContentUrl.length > 0) ||
            alertInfo[0].serviceType === "three-bureau-credit-monitoring" ||
            alertInfo[0].serviceType === "single-bureau-credit-monitoring" ||
            alertInfo[0].serviceType === "ssn-trace" ||
            alertInfo[0].serviceType === "criminal-records-monitoring" ||
            alertInfo[0].serviceType === "short-term-loan" ||
            alertInfo[0].serviceType === "advanced-fraud-monitoring"
        ) {
            return renderIframe();
        } else if (isTUAlert && alertInfo[0].alertDetails.rawContentUrl) {
            return renderTUAlerts();
        } else {
            return renderAlertDetails();
        }
    };

    return <>{renderAlerts()}</>;
};

export default NameAddress;
